import { Permission, RFIStatus } from '@cims-online/shared'
import { useRFITrackerContext } from '../../../../../../RFITrackerContext'
import { Button } from 'antd'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { toMoment } from 'utils/toMoment'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { RequestForInformation } from '../../../../../../RFITrackerContext/types'

const Status: React.FC<RequestForInformation> = ({
  id,
  number,
  statusId,
  deleted,
  description,
  responseDisciplines,
  responses,
  organizationId,
  requestedResponseDate,
  externalLinks,
  customFields,
}) => {
  const {
    draftSubmitModal: { toggle },
  } = useRFITrackerContext()
  const { toCustomFieldEditorValue } = useProjectCustomFieldsContext()
  const canDraft = useCheckPermission(Permission.CreateRequestForInformation)
  return (
    <>
      {statusId === RFIStatus.Draft.id ? (
        <Button
          disabled={deleted || !canDraft}
          type="link"
          onClick={() =>
            toggle({
              id,
              number,
              description,
              responseDisciplineIds: responseDisciplines.map(({ id }) => id),
              responses,
              organizationId,
              requestedResponseDate: toMoment(requestedResponseDate),
              externalLinks:
                externalLinks?.map(({ __typename, ...link }) => link) ?? [],
              customFields: toCustomFieldEditorValue(customFields),
            })
          }
        >
          Draft
        </Button>
      ) : (
        RFIStatus.fromIdOrFail(statusId).name
      )}
    </>
  )
}

export default Status
